import { Link } from "react-router-dom";
import { SITE } from "../data/site";

export default function MobileCTA() {
  return (
    <div className="mobile-cta">
      <a className="is-call" href={`tel:${SITE.phoneTel}`}>
        Anrufen
      </a>
      <a
        className="is-wa"
        href={SITE.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        WhatsApp
      </a>
      <Link className="is-mail" to="/kontakt">
        Anfragen
      </Link>
    </div>
  );
}
